import React, { useState } from "react";
import Header from "../pages/layouts/Header";
import Footer from "../pages/layouts/Footer";

import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";

const HelpCenter = () => {
  const [activeTab, setActiveTab] = useState("v-pills-home");

  const handleTabClick = (tabId) => {
    setActiveTab(tabId);
  };
  const carouselItems = [
    {
      title: "Fashion",
      imagePath: require("../assets/images/header_icons/menu-1.png"),
    },
    {
      title: "Electronics",
      imagePath: require("../assets/images/header_icons/menu-2.jpg"),
    },
    {
      title: "Appliances",
      imagePath: require("../assets/images/header_icons/menu-3.jpg"),
    },
    {
      title: "Repair",
      imagePath: require("../assets/images/header_icons/menu-4.jpg"),
    },
    {
      title: "Home",
      imagePath: require("../assets/images/header_icons/menu-5.jpg"),
    },
    {
      title: "Grooming",
      imagePath: require("../assets/images/header_icons/menu-6.jpg"),
    },
    {
      title: "Home",
      imagePath: require("../assets/images/header_icons/menu-7.png"),
    },
    {
      title: "Travel",
      imagePath: require("../assets/images/header_icons/menu-8.jpg"),
    },
    {
      title: "Repair",
      imagePath: require("../assets/images/header_icons/menu-9.jpg"),
    },
    {
      title: "Vegetables",
      imagePath: require("../assets/images/header_icons/menu-10.jpg"),
    },
    {
      title: "Grocery",
      imagePath: require("../assets/images/header_icons/menu-11.jpg"),
    },
    {
      title: "Self jobs",
      imagePath: require("../assets/images/header_icons/menu-12.jpg"),
    },
    {
      title: "Vehicle care",
      imagePath: require("../assets/images/header_icons/menu-13.jpg"),
    },
    {
      title: "Food",
      imagePath: require("../assets/images/header_icons/menu-14.jpg"),
    },
  ];

  const scrollMenuOwlOptions = {
    items: 10, // Display 10 items at a time
    loop: true,
    margin: 10,
    nav: true,
    dots: false,
    navText: [
      '<i class="fa fa-chevron-left"></i>',
      '<i class="fa fa-chevron-right"></i>',
    ],
    slideBy: 1, // Scroll one item at a time
    responsive: {
      0: {
        items: 3,
      },
      576: {
        items: 4,
      },
      768: {
        items: 6,
      },
      992: {
        items: 8,
      },
      1200: {
        items: 10,
      },
    },
  };

  return (
    <>
      <Header />
      <div className="scrollmenu">
        <OwlCarousel
          className="owl-carousel"
          id="scroll_menu"
          {...scrollMenuOwlOptions}
        >
          {carouselItems.map((item, index) => (
            <div key={index} className="item">
              <a className="nav-link" href="#">
                <img
                  className="header_icons"
                  src={item.imagePath}
                  alt={item.title}
                />
                {item.title}
              </a>
            </div>
          ))}
        </OwlCarousel>
      </div>
      <section className="comnpadding help_center">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h5>
                <strong>
                  TrustApp Help Center | 24x7 Customer Care Support
                </strong>
              </h5>
              <p>
                <small>
                  To access support, please log into the app and click on the three lines located on the top left side of the page. From the panel that appears, select the last option, "Contact Support"
                </small>
              </p>
            </div>
          </div>
          <div className="row">
            <div className="col-xl-12">
              <div className="helptab">
                <div className="tabmenu">
                  <div
                    className="nav flex-column nav-pills"
                    id="v-pills-tab"
                    role="tablist"
                    aria-orientation="vertical"
                  >
                    <h6>
                      <strong>Service Provider (मेरा बिज़नेस/पेशा है)</strong>
                    </h6>
                    <button
                      className={`nav-link ${
                        activeTab === "v-pills-home" ? "active" : ""
                      }`}
                      onClick={() => handleTabClick("v-pills-home")}
                      id="v-pills-home-tab"
                      data-bs-toggle="pill"
                      data-bs-target="#v-pills-home"
                      type="button"
                      role="tab"
                      aria-selected={activeTab === "v-pills-home"}
                    >
                      How can I register my business or profession
                    </button>
                    <button
                      className={`nav-link ${
                        activeTab === "v-pills-profile" ? "active" : ""
                      }`}
                      onClick={() => handleTabClick("v-pills-profile")}
                      id="v-pills-profile-tab"
                      data-bs-toggle="pill"
                      data-bs-target="#v-pills-profile"
                      type="button"
                      role="tab"
                      aria-selected={activeTab === "v-pills-profile"}
                    >
                      What is monthly charges for a business or profession
                    </button>
                    <button
                      className={`nav-link ${
                        activeTab === "v-pills-messages" ? "active" : ""
                      }`}
                      onClick={() => handleTabClick("v-pills-messages")}
                      id="v-pills-messages-tab"
                      data-bs-toggle="pill"
                      data-bs-target="#v-pills-messages"
                      type="button"
                      role="tab"
                      aria-selected={activeTab === "v-pills-messages"}
                    >
                      How can I advertise my business or profession
                    </button>
                    <button
                      className={`nav-link ${
                        activeTab === "v-pills-messages1" ? "active" : ""
                      }`}
                      onClick={() => handleTabClick("v-pills-messages1")}
                      id="v-pills-messages1-tab"
                      data-bs-toggle="pill"
                      data-bs-target="#v-pills-messages1"
                      type="button"
                      role="tab"
                      aria-selected={activeTab === "v-pills-messages1"}
                    >
                      How to view my business (service provider) profile?
                    </button>

                    <h6>
                      <strong>Customer (कस्टमर)</strong>
                    </h6>
                    <button
                      className={`nav-link ${
                        activeTab === "v-pills-help1" ? "active" : ""
                      }`}
                      onClick={() => handleTabClick("v-pills-help1")}
                      id="v-pills-help1-tab"
                      data-bs-toggle="pill"
                      data-bs-target="#v-pills-help1"
                      type="button"
                      role="tab"
                      aria-selected={activeTab === "v-pills-help1"}
                    >
                      How to create a customer profile
                    </button>
                    <button
                      className={`nav-link ${
                        activeTab === "v-pills-help2" ? "active" : ""
                      }`}
                      onClick={() => handleTabClick("v-pills-help2")}
                      id="v-pills-help2-tab"
                      data-bs-toggle="pill"
                      data-bs-target="#v-pills-help2"
                      type="button"
                      role="tab"
                      aria-selected={activeTab === "v-pills-help2"}
                    >
                      How can I advertise event, match or election messages
                    </button>
                    <button
                      className={`nav-link ${
                        activeTab === "v-pills-help3" ? "active" : ""
                      }`}
                      onClick={() => handleTabClick("v-pills-help3")}
                      id="v-pills-help3-tab"
                      data-bs-toggle="pill"
                      data-bs-target="#v-pills-help3"
                      type="button"
                      role="tab"
                      aria-selected={activeTab === "v-pills-help3"}
                    >
                      What is monthly charges for a customer profile
                    </button>

                  </div>
                </div>
                <div className="tabtext">
                  <div className="tab-content" id="v-pills-tabContent">
                    <div
                      className={`tab-pane fade show ${
                        activeTab === "v-pills-home" ? "active" : ""
                      }`}
                      id="v-pills-home"
                      role="tabpanel"
                      aria-labelledby="v-pills-home-tab"
                    >
                      <h5>Service Provider</h5>
                      <p>
                        To list your business in the app, create a profile and
                        switch it to a Service Provider profile. You can switch
                        between customer and service provider profiles in the
                        app as needed. Verify your profile with a one-time
                        payment of Rs.1 for security. Follow the steps in this{" "}
                        <a href="https://youtu.be/jvJ4PoeMdgI">YouTube video</a>
                        . You can also visit our{" "}
                        <a href="https://www.youtube.com/channel/UCgfsP87JzGYHCSC3tURPN3g">
                          YouTube channel
                        </a>
                        .
                      </p>
                      <p>
                        एक कस्टमर प्रोफाइल बनाये फिर उसको सर्विस प्रोवाइडर में
                        चेंज कर ले. इस{" "}
                        <a href="https://youtu.be/8umoz5NH2Oo">वीडियो</a> को
                        देखें. एक ही ऐप को दोनों प्रोफाइल के लिए उपयोग किया जा
                        सकता है, आप जरूरत के अनुसार ऐप में कस्टमर और सर्विस
                        प्रोवाइडर प्रोफाइल में स्विच कर सकते हैं.
                      </p>
                    </div>
                    <div
                      className={`tab-pane fade ${
                        activeTab === "v-pills-profile" ? "show active" : ""
                      }`}
                      id="v-pills-profile"
                      role="tabpanel"
                      aria-labelledby="v-pills-profile-tab"
                    >
                      <h5>Service Provider</h5>
                      <p>
                        In general, we charge Rs.1 monthly per category. No
                        order, no monthly charge for service providers (business
                        profiles visible in the app) until they receive orders.
                        Follow this YouTube video to make monthly payments.
                        Customer profiles are always free. एप से बिज़नेस चलाने
                        के लिए मात्र Rs.1 मंथली लिए जाते हैं। सर्विस प्रोवाइडर
                        को आर्डर मिलने पे ही ट्रस्ट ऐप मंथली पेमेंट चार्ज करता
                        है।
                      </p>
                    </div>
                    <div
                      className={`tab-pane fade ${
                        activeTab === "v-pills-messages" ? "show active" : ""
                      }`}
                      id="v-pills-messages"
                      role="tabpanel"
                      aria-labelledby="v-pills-messages-tab"
                    >
                      <h5>Service Provider</h5>
                      <p>
                        Use our "Broadcast", "AD", and "Business Offers"
                        category features to advertise your products.
                      </p>
                    </div>
                    <div
                      className={`tab-pane fade ${
                        activeTab === "v-pills-messages1" ? "show active" : ""
                      }`}
                      id="v-pills-messages1"
                      role="tabpanel"
                      aria-labelledby="v-pills-messages1-tab"
                    >
                      <h5>Service Provider</h5>
                      <p>
                        Follow this{" "}
                        <a
                          href="https://www.youtube.com/watch?v=qfbNBs0h378"
                          target="_blank"
                        >
                          YouTube video
                        </a>
                        .
                      </p>
                    </div>

                    {/* Add more tab panes for other tabs with similar structure */}
                    <div
                      className={`tab-pane fade ${
                        activeTab === "v-pills-help1" ? "show active" : ""
                      }`}
                      id="v-pills-help1"
                      role="tabpanel"
                      aria-labelledby="v-pills-help1-tab"
                    >
                      <h5>Customer</h5>
                      <p>
                        Follow steps shown in this{" "}
                        <a
                          href="https://www.youtube.com/playlist?list=PLGPpgDt6rdY99nCCp3eSSMCpYtSS7ZiwE"
                          target="_blank"
                        >
                          YouTube video
                        </a>
                        .
                      </p>
                    </div>
                    <div
                      className={`tab-pane fade ${
                        activeTab === "v-pills-help2" ? "show active" : ""
                      }`}
                      id="v-pills-help2"
                      role="tabpanel"
                      aria-labelledby="v-pills-help2-tab"
                    >
                      <h5>Customer</h5>
                      <p>
                        Use our "Broadcast", "AD", and "Business Offers"
                        category features to advertise your products.
                      </p>
                    </div>
                    <div
                      className={`tab-pane fade ${
                        activeTab === "v-pills-help3" ? "show active" : ""
                      }`}
                      id="v-pills-help3"
                      role="tabpanel"
                      aria-labelledby="v-pills-help3-tab"
                    >
                      <h5>Customer</h5>
                      <p>
                        There is no charge for a customer profile. But if you
                        want to get bids, verify your profile with a one-time
                        payment of Rs.1 for security.
                      </p>
                    </div>
                    <div
                      className={`tab-pane fade ${
                        activeTab === "v-pills-help4" ? "show active" : ""
                      }`}
                      id="v-pills-help4"
                      role="tabpanel"
                      aria-labelledby="v-pills-help4-tab"
                    >
                      <h5>Jobs, Partner</h5>
                      <p>
                        Currently, we are hiring for Local Admin, Sales
                        Executive, Telecaller, Delivery Partners & Delivery
                        Admins. Visit the links for requirements.
                      </p>
                    </div>
                    <div
                      className={`tab-pane fade ${
                        activeTab === "v-pills-help5" ? "show active" : ""
                      }`}
                      id="v-pills-help5"
                      role="tabpanel"
                      aria-labelledby="v-pills-help5-tab"
                    >
                      <h5>Jobs, Partner</h5>
                      <p>
                        ZERO. Never pay anyone for any job at Trust app. Report
                        to Trust support team if anyone asks for money for
                        Trust's jobs.
                      </p>
                    </div>
                    <div
                      className={`tab-pane fade ${
                        activeTab === "v-pills-help6" ? "show active" : ""
                      }`}
                      id="v-pills-help6"
                      role="tabpanel"
                      aria-labelledby="v-pills-help6-tab"
                    >
                      <h5>Jobs, Partner</h5>
                      <p>
                        We never fire our employees. Our employees are assets.
                      </p>
                    </div>
                    <div
                      className={`tab-pane fade ${
                        activeTab === "v-pills-help7" ? "show active" : ""
                      }`}
                      id="v-pills-help7"
                      role="tabpanel"
                      aria-labelledby="v-pills-help7-tab"
                    >
                      <h5>Jobs, Partner</h5>
                      <p>
                        Email to contact@cloudai.in with subject "Partner with
                        Trust".
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer/>
    </>
  );
};

export default HelpCenter;
